import gql from "graphql-tag";

export const Query = gql`
  query Node(
    $id: ID!
    $filter: VehicleJourneyFilter!
    $speedUnit: SpeedUnit!
    $distanceUnit: DistanceUnit!
  ) {
    node(id: $id) {
      ...Journey_vehicle_tracking
    }
  }

  fragment Journey_vehicle_tracking on Vehicle {
    id
    device {
      cameras {
        id
        location
      }
    }
    journey(filter: $filter) {
      drives {
        start
        end
        duration
        driverId
        driver {
          id
          name
        }
        averageSpeed(unit: $speedUnit)
        topSpeed(unit: $speedUnit)
        driveLength(unit: $distanceUnit)
      }
      markers {
        coord {
          lat
          lng
        }
        timestamp
        speed(unit: $speedUnit)
      }
      stops {
        coord {
          lat
          lng
        }
        start
        end
        duration
        stopaddressstring
      }
    }
    live {
      online
      driver {
        name
        id
      }
      video {
        camera
        label
        cameraId
        streams {
          type
          contentType
          source
        }
      }
    }
  }
`;
